import tokens from './tokens';

// Flat CSS custom properties mirrored from `tokens.js` so plain CSS
// files (`installPage.css`, `landingPage.css`, any legacy page CSS) can
// reach for the same design tokens the MUI theme uses.
//
// Mounted at app root via <GlobalStyles styles={cssVars}/> so these are
// available under the :root selector everywhere.
export const cssVars = {
    ':root': {
        // Brand
        '--ba-amber':        tokens.color.amber,
        '--ba-amber-dark':   tokens.color.amberDark,
        '--ba-amber-deep':   tokens.color.amberDeep,
        '--ba-amber-tint':   tokens.color.amberTint,
        '--ba-amber-wash':   tokens.color.amberWash,

        // Ink
        '--ba-ink':          tokens.color.ink,
        '--ba-ink-strong':   tokens.color.inkStrong,
        '--ba-ink-muted':    tokens.color.inkMuted,
        '--ba-ink-soft':     tokens.color.inkSoft,

        // Surfaces
        '--ba-bg':           tokens.color.bg,
        '--ba-bg-soft':      tokens.color.bgSoft,
        '--ba-bg-cream':     tokens.color.bgCream,

        // Lines
        '--ba-line':         tokens.color.line,
        '--ba-line-warm':    tokens.color.lineWarm,

        // Dark mode (future)
        '--ba-dark-1':       tokens.color.dark1,
        '--ba-dark-2':       tokens.color.dark2,
        '--ba-dark-3':       tokens.color.dark3,
        '--ba-on-dark':      tokens.color.onDark,
        '--ba-on-dark-soft': tokens.color.onDarkSoft,
        '--ba-on-dark-mute': tokens.color.onDarkMute,

        // Radius / shadow / motion
        '--ba-radius-sm':    `${tokens.radius.sm}px`,
        '--ba-radius-md':    `${tokens.radius.md}px`,
        '--ba-radius-lg':    `${tokens.radius.lg}px`,
        '--ba-shadow-sm':    tokens.shadow.sm,
        '--ba-shadow-md':    tokens.shadow.md,
        '--ba-shadow-lg':    tokens.shadow.lg,
        '--ba-shadow-amber': tokens.shadow.amber,
        '--ba-ease':         tokens.ease,
        '--ba-font-family':  tokens.fontFamily,
    },
};

export default cssVars;
